// Suggested tribes list
.signup-tribe-suggestions {
  h4 {
    margin-top: 50px;
    margin-bottom: 10px;
    padding: 0;
    text-align: center;
  }
  .tribe-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    color: #fff;
    padding: 0 20px;
    min-height: 120px;
    margin: 0;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.65) 0%,
      rgba(0, 0, 0, 0) 100%
    );
  }
  .tribe-label {
    margin: 0;
    padding: 0;
    font-size: 30px;
    line-height: 1;
  }
}
